import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/subMinutes/index.js';

var require$$12 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$12 as default };
